export const NO = {
  preparing_zip: "Forbereder zip…",
  compressing: "Komprimerer…",
  info_icon: "Når den er merket som fullført, kan ingen ytterligere medlemmer bli med eller legges til, og alle chatgrupper vil bli deaktivert. Vær oppmerksom på at prosjektet, sammen med alle chatgrupper og data, vil forbli tilgjengelig i en deaktivert tilstand.",
  mark_is_done: "Er du sikker på at du vil markere prosjektet som fullført? Når det er merket, kan ingen ytterligere medlemmer bli med eller legges til, og alle chatgrupper vil bli deaktivert. Vær oppmerksom på at prosjektet, sammen med alle chatgrupper og data, vil forbli tilgjengelig i en deaktivert tilstand.",
  mark_not_done: "Er du sikker på at du vil åpne prosjektet igjen? Når det er merket som åpent, kan ytterligere medlemmer bli med eller legges til, og alle chatgrupper vil bli reaktivert.",
  mark_as_completed: "Merk prosjekt som fullført",
  room_completed: "Prosjekt fullført",
  room_members: "Prosjektets medlemmer",
  deactivated_rooms: "Deaktiverte prosjekter",
  deactivated_chats: "Deaktiverte chatter",
  completed_rooms: "Fullførte prosjekter",
  request_to_join_a_room: 'Forespørsel om å bli med i prosjektet',
  wants_to_rejoin_room: 'Username ønsker å bli med i prosjektet Roomname igjen.',
  invited_you_to_join_room: 'Username har invitert deg til å bli med i prosjektet Roomname.',
  restart: "Start på nytt",
  update_text: "En ny oppdatering er tilgjengelig. Klikk på start på nytt for å installere oppdateringen.",
  update_availble: "Oppdatering tilgjengelig",
  Loading: "Laster...",
  logout: "Logg ut",
  back: 'Tilbake',
  company_list: "Firmaliste",
  followers: "Følgere",
  followings: "Følger",
  article: "Artikkel",
  companies: "Firmaer",
  one_to_one_chat: " En-mot-en chat",
  profile: "Profil",
  company: "Firma",
  company_selection: "Firmaval",
  home: "Hjem",
  contact: "Kontakt ",
  add_company: "Legg til firma ",
  add_project: "Legg til prosjekt ",
  capacities: "Kapasiteter ",
  work_area: "Arbeidsområde",
  company_services: "Firmas tjenester",
  website: "Nettsted",
  search_contacts: "Søk kontakter",
  add_or_join_a_company: "Legg til eller bli med i et firma",
  follow: "Følg",
  following: "Følger",
  like: "Liker",
  company_contacts: "Firmakontakt",
  leave_the_company: "Forlat firmaet",
  news: "Nyheter",
  earlier: "Tidligere",
  action: "Handling",
  another_action: "En annen handling",
  something_else: "Noe annet",
  search: "Søk",
  search_rooms: "Søk prosjekter",
  search_articles: "Søk artikler",
  contacts: "Kontakter",
  suggestions: "Forslag",
  project_list: "Prosjektliste",
  search_results: "Søkeresultater",
  add_or_join_project: "Legg til eller bli med i prosjekt",
  details: "Detaljer",
  your_position_within_company:
    "Vennligst velg din stilling i firmaet.",
  close_modal: "Lukk",
  map: "Kart",
  or: "Eller",
  name: "Navn*",
  street: "Gate*",
  house_number: "Husnummer",
  postal_code: "Postnummer",
  city: "By*",
  opened_by: "Åpnet av:",
  project_No: "Prosjektnummer: ",
  building_type: "Bygningstype*",
  building_types: "Bygningstype",
  add_join: "Legg til/Bli med",
  mandatory_fiels: "*obligatoriske felt",
  invalid_fiels: "Dette feltet er påkrevd",
  add_or_join_company: "Legg til eller bli med i firma",
  name_of_the_company: "Firmas navn",
  edit_company_details: "Rediger firmadetaljer",
  branch_of_the_building_industry: "Gren av byggebransjen",
  corporate_form: "Selskapsform",
  position_within_company: "Stilling i firmaet",
  request_confirmation: "Ventende prosjektforespørsler",
  company_e_mail: "Firmas e-post",
  type_of_filter: "Skriv for å filtrere...",
  setting: "Innstilling",
  dashboard: "Dashbord",
  settings: "Innstillinger",
  views: "Visninger",
  times_seen: "ganger sett",
  see_more: "...mer",
  see_less: "...mindre",
  in_search: "i søket",
  reset_password: "Tilbakestill passord",
  submit: "Send",
  password: "Passord",
  email: "E-post",
  confirm_password: "Bekreft passord",
  reset_email: "Tilbakestill e-post",
  update: "Oppdater",
  new_email: "Ny e-post",
  kjuup_message: "Kjuup Melding",
  delete_profile: "Slett profil?",
  my_position: "Min stilling:",
  add: "legg til",
  owner_company_admin: "Firmaadministrator :",
  owner_company_admin_new: "Firmaadministrator",
  mutual_contact: "felles kontakt",
  mutual_contacts: "felles kontakter",
  co_owner: "Medeier",
  managing_director: "Daglig leder",
  associate: "Medarbeider",
  secretary: "Sekretær",
  employee: "Ansatt",
  project_manage: "Prosjektleder",
  auto_chat_translation: "Automatisk chatoversettelse",
  translate_room_group_names: "Oversett chatgruppenavn",
  translate_room_group_names_info: "Når det er aktivert, oversettes chatgruppenavn automatisk til grensesnittspråket ditt.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Når aktivert, åpnes E-Post-fanen som standard i stedet for Meldinger når du åpner appen.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Språk",
  english: "Engelsk",
  german: "Tysk",
  french: "Fransk",
  italian: "Italiensk",
  change_language: "Endre språk",
  my_companies: "Mine firmaer",
  employees: "Ansatte",
  invite_with_a: "Inviter til Kjuup",
  add_member: "Legg til medlem",
  add_user: "Legg til bruker",
  send_location: "Send plassering",
  assign_admin_rights: "Juster administratorrett",
  deactivate_company: "Deaktiver firma",
  remove_employees: "Fjern ansatte",
  remove_members: "Fjern medlemmer",
  no_user_found: "Ingen bruker funnet!",
  approve: "Godkjenn!",
  deselect_all: "Fjern valg av alle",
  select_all: "Velg alle",
  translation_on_building_projects: "Oversettelse i prosjekter",
  reported_capacities: "Rapporterte tjenester",
  up_to_50m_exact: "Opp til 50m nøyaktig",
  company_details_service: "Firmas tjenester",
  company_contact: "Firmakontakt",
  invite_with_link: "Inviter til Kjuup",
  share_link: "Del lenke",
  share_company_link: "Del lenke",
  qr_code: "QR-kode",
  copy_link: "Kopier lenke",
  cancel_link: "Avbryt lenke",
  who_has_confirmed_services: "Hvem har bekreftet dine tjenester?",
  projectss: "Prosjekter",
  add_services: "Legg til tjenester",
  services: "Tjenester",
  save_text: "Lagre",
  share_on: "Del på:",
  articlen: "Artikkel",
  invite_user_to_confirm_service:
    "Inviter brukere til å bekrefte tjenester til firmaet.",
  link_copied: "Lenke kopiert!",
  email_copied: "E-post kopiert!",
  personal_article: "Personlig artikkel",
  company_article: "Firmaartikkel",
  characters_remaining: "Gjenstående tegn",
  optional_information: "Valgfri informasjon",
  project: "Prosjekt",
  projects: "Prosjekter...",
  abort: "Forkast",
  preview: "Forhåndsvisning",
  post: "Publiser",
  of: "av",
  remove: "Fjern",
  free_capacity: "Jobbportal",
  current_status_overview: "Oversikt over nåværende status",
  report_capacities: "Rapporter tjenester",
  report_text: "Rapporter",
  search_capacities: "Finn entreprenører",
  add_project_user: "Legg til prosjektbruker",
  media: "Media",
  links: "Lenker",
  docs: "Dokumenter",
  featured_products: "Utvalgte produkter...",
  title: "Tittel",
  text: "Tekst",
  feed_details: "Feed-detaljer",
  add_employee: "Legg til ansatt",
  latest: "Siste",
  my_projects: "Mine prosjekter",
  cancel: "Avbryt",
  continue: "Fortsett",
  role_in_the_building_industry: "Rolle i byggebransjen",
  als: "som",
  join: "bli med",
  find: "Finn",
  request_to_join_a_company: "Forespørsel om å bli med i firmaet",
  wants_to_join_the_company: "ønsker å bli med i firmaet",
  filter_by: "Filtrer etter",
  ok: "Ok",
  close: "Lukk",
  weekly_statistics: "Ukestatistikk",
  is_following_you: "følger deg.",
  as: "som",
  has_joined_the: "har blitt med i firmaet",
  has_looked_at_your_profile: "har sett på din profil.",
  time: "Tid",
  in_searches_in_past_week: "i søk forrige uke.",
  has_liked_your_article: "har likt din artikkel.",
  has_published_a_new_article: "har publisert en ny artikkel.",
  you: "Du",
  all_views: "Alle visninger",
  all_profile_views: "Alle profilvisninger",
  mutual_company: "felles firma",
  artical_text: "Skriv artikkel...",
  you_have_appeared: "Du har dukket opp",
  your_request_at_the_company: "Din forespørsel i firmaet",
  times_you_have_appeared_in_searches: "ganger du har dukket opp i søk",
  appear_more_often_in_searches: "Dukk opp oftere i søk",
  you_have_been_found: "Du har blitt funnet",
  improve_profile: "Forbedre profil",
  choose_existing_contact_for_single_chat:
    "Velg eksisterende kontakt for enkel chat:",
  in_order_to_add_new_contacts:
    "For å legge til nye kontakter, vennligst søk etter nye kontakter på profilsiden.",
  times_in_searches_in_the_last_week:
    "ganger i søk forrige uke. Oppdater din profil og legg til flere detaljer for å bli funnet lettere.",
  has_been_confirmed: "har blitt bekreftet.",
  have_joined_the: "har blitt med i  ",
  building_project: " byggeprosjekt.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Velg firmaet du vil representere. Dette vil bli vist til andre deltakere.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Velg firmaet du vil representere. Dette vil bli vist til andre deltakere.",
  select_internal_section: "Vennligst velg intern seksjon",
  select_profile_image: "Velg profilbilde",
  share_user: "Del bruker",
  contact_sender_message:
    "Del denne lenken for å invitere en ikke-medlem av Kjuup til Kjuup. Denne lenken kan brukes av flere personer for å registrere seg.",
  project_sender_message:
    "Del denne lenken for å invitere en ikke-medlem av Kjuup til prosjektet prosjektnavn. Denne lenken kan brukes av flere personer for å registrere seg og bli med i prosjektet prosjektnavn i Kjuup.",
  company_sender_message:
    "Del denne lenken for å invitere en ikke-medlem av Kjuup til firmaet firmasnavn. Denne lenken kan brukes av flere personer for å registrere seg og bli med i firmaet i Kjuup.",
  contact_receivers_message:
    "Invitasjonslenke for å bli med i Kjuup. Vennligst klikk på lenken for å registrere deg for kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "Hvis du installerer Kjuup via Apple App Store, må du klikke på denne lenken etter vellykket nedlasting for å kunne registrere deg.",
  project_receivers_message:
    "Invitasjonslenke for å bli med i prosjektet prosjektnavn i Kjuup. Vennligst klikk på lenken for å registrere deg for Kjuup og bli med i prosjektet prosjektnavn.",
  company_receivers_message:
    "Invitasjonslenke til firmaet firmasnavn i Kjuup. Vennligst klikk på lenken for å registrere deg for Kjuup og bli med i firmaet firmasnavn.",
  sign_in: "Logg inn",
  enter_your_email_add: "Skriv inn din e-postadresse",
  forgot_password: "Glemt passord",
  dont_have_account: "Har du ikke en konto?",
  register: "Registrer",
  get_app: "Hent appen",
  registration: "Registrering",
  dep_ing: "Dipl.-Ing.",
  dr: "Dr.",
  dr_ing: "Dr.-Ing.",
  dep_ing_arc: "Dipl.-Ing. Arkitekt",
  prof: "Prof.",
  first_name: "Fornavn",
  last_name: "Etternavn",
  have_an_account: "Har du en konto?",
  when_register_you_agree: "Når du registrerer deg, godtar du våre",
  term_of_use: "bruksvilkår",
  to: ".",
  in_our: "I vår",
  data_policy: "datapolicy",
  they_find_out: "får du vite,",
  we_provide_store_data: "hvordan vi samler inn, behandler og lagrer informasjon.",
  leaving_company_text:
    "Vil du virkelig forlate firmaet? Når du forlater firmaet, forlater du også alle tilknyttede prosjekter og chatgrupper. Du kan bli med i disse prosjektene igjen med et annet firma når som helst.",
  delete_profile_text:
    "Vil du virkelig slette din profil? Når du sletter din profil, vil alle tilkoblinger til firmaer, prosjekter og chatter bli fjernet. Du kan opprette en ny profil når som helst.",
  confirm: "Bekreft",
  reject: "Avvis",
  requet_to_leave: "Forespørsel om å forlate",
  choose: "Velg",
  your_add_member: "Legg til medlem",
  if_you: "i tilfelle du",
  can_not_find: "ikke kan finne din kontakt her.",
  please_wait: "Vennligst vent..",
  imprint_gtc: "Impressum/Allmennvilkår",
  register_confirm_popup: "Bekreft Kjuup-e-postadressen din før du logger inn. Vi har sendt en bekreftelseslenke. Hvis du ikke ser den, sjekk også søppelpostmappen.",
  PENDING_GROUP_USER:
    "vil kun motta meldinger etter at invitasjonen til prosjektet har blitt bekreftet. En ekstra melding vil vises når invitasjonen til prosjektet har blitt bekreftet.",
  PENDING: "Bekreftelse av invitasjon til prosjektet venter",
  denied_group_chat: " har avslått invitasjonen til prosjektet og har forlatt denne gruppen.",
  // joined_group_chat: " har blitt med i rommet og denne gruppen.",
  joined_group_chat: " ble med i denne gruppen",
  you_joined_group_chat: "Du ble med i denne gruppen.",
  Others: "Andre",
  LEFT_GROUP: "har forlatt denne chatgruppen.",
  YOU_LEFT_GROUP: "har forlatt denne chatgruppen.",
  days: "dager",
  day: "dag",
  hour: "time",
  hide_project: "Skjul prosjekt",
  hide_project_popup_text:
    "Hvis du skjuler prosjekter, kan de ikke bli funnet i Kjuup. Bare medlemmer av prosjektet kan invitere nye brukere til prosjektet.",
  branch: "Gren",
  photo_video_media_lib: "Foto - Video mediebibliotek",
  document: "Dokument",
  location_meeting: "Plassering / Møte",
  all_member_of_project: "Alle medlemmer av prosjektet",
  pending_request: "Ventende prosjektforespørsler",
  no_pending_request: "Ingen ventende forespørsler funnet!",
  news_feed: "Nyhetsfeed",
  user_info: "Gruppeinfo",
  leave_project: "Forlat prosjekt",
  media_link_docs: "Filer",
  search_chat: "Søk chat",
  export_chat_group: "Eksporter chatgruppedata fra forrige måned",
  request_complete_chat_history: "Be om komplett chatthistorikk",
  leave_chat_group: "Forlat chatgruppe",
  add_user_project: "Legg til bruker",
  me: "Meg",
  max_open_one_to_one:
    "For øyeblikket kan maks. 2 en-mot-en chatter åpnes parallelt i nedre og øvre seksjon. Totalt er maks. 4 en-mot-en chatter mulig.",
  are_you_sure_you_want_leave_chat:
    "Er du sikker på at du vil forlate denne chatgruppen?",
  create_group: "Opprett gruppe",
  adding_members: "Legger til medlemmer...",
  creating_the_chat: "Oppretter chatten...",
  finishing_setup: "Fullfører...",
  group_name: "Gruppenavn",
  by: "Av:",
  mandetory: "*obligatorisk",
  delteed: "har slettet sin profil og har forlatt gruppechatten.",
  deleted_direct: "har slettet sin profil og har forlatt chatten.",
  unhidden_message:
    "Hvis du viser prosjekter, kan de bli funnet av alle medlemmer av Kjuup.",
  account_deleted: "Kontoen har blitt slettet.",
  refuse_company: "Er du sikker på at du vil avslå firmaets invitasjon?",
  follow_additional: "Følg ytterligere brukere",
  f_add:
    "Følg ytterligere brukere av Kjuup for å gjøre dem tilgjengelige for direkte meldinger.",
  c_inv: "Firmainvitasjon(er)",
  invited_o_Company: "Du har blitt invitert til å bli med i firmaet",
  refuse_companyX: "Er du sikker på at du vil avslå firmaets forespørsel?",
  a_Da: "Konto deaktivert.",
  has_deactivated: "har deaktivert sin profil.",
  reactive: "har reaktivert sin profil.",
  juup_note: "*Registrering med brukernavn kun tilgjengelig for medlemmer av Kjuup+",
  username: "Brukernavn*",
  email_username: "E-post/Brukernavn*",
  sPinText:
    "Vennligst oppgi en 6-sifret sikkerhets-PIN. Denne PIN-en vil være nødvendig hvis du glemmer passordet ditt og er obligatorisk for å bekrefte kontoen din.",
  DeleteKjuupPlusText:
    "Vil du virkelig slette din profil? Når du sletter din profil, vil alle tilkoblinger til firmaer, prosjekter og chatter bli fjernet.\n\nInnen 48 timer etter kontosletting kan du reaktivere kontoen din ved å logge inn med brukernavn, passord og PIN.",
  reactive_text:
    "Kontoen din har blitt slettet. Vennligst klikk på Reaktiver for å reaktivere kontoen din.",
  rac: "Reaktiver",
  ac_ss: "Kontoen har blitt reaktivert vellykket.",
  not_valid_pin: "PIN ugyldig",
  only_for_kjuup:
    "*Tilbakestilling av passord via brukernavn og PIN kun tilgjengelig for Kjuup+ medlemmer.",
  resetPIN: "Tilbakestill PIN",
  enter_current_pin: "Vennligst skriv inn din nåværende PIN",
  enter_new: "Skriv inn ny PIN",
  pin_to_confirm: "Vennligst oppgi PIN-en for å bekrefte.",
  change_username: "Tilbakestill brukernavn",
  pp_not_match: "Passord og Bekreft passord stemmer ikke overens",
  reactive_itself: "Du har reaktivert din profil.",
  has_deactivated_itself: "Du har deaktivert din profil.",
  more_than_two:
    "For øyeblikket kan direkte meldinger kun gjøres med 2 brukere parallelt.",
  Chats: "Direkte meldinger",
  only_in_mobileL:
    "Innebygde videoer kan for øyeblikket kun lastes opp og publiseres via mobilappen. Vennligst bruk videolenker fra Youtube og Vimeo.",
  register_pin_text:
    "Vennligst velg din personlige 6-sifrede PIN. Denne PIN-en vil være nødvendig for å aktivere kontotilbakestillingsfunksjoner.",
  internal_project: "Intern",
  external_projects: "Ekstern",
  in_deacticted: "Intern seksjon er deaktivert.",
  create_article: "Opprett artikkel",
  new_article_selection: "Opprett artikkel for ekstern nyhetsfeed",
  new_article_selection_internal: "Opprett intern artikkel",
  active_trans_title: "Slå på automatisk oversettelse?",
  active_trans: "Når den er aktivert, vil alle innkommende chatmeldinger bli oversatt til ditt valgte applikasjonsspråk.",
  disable_trans: "Vil du virkelig deaktivere automatisk oversettelse?",
  allow_access_chat: "Vis full chatthistorikk",
  toggle_chat_history_on:
    "Vil du virkelig at brukeren skal se full chatthistorikk?",
  toggle_chat_history_off:
    "Vil du virkelig at brukeren kun skal se chatthistorikken fra det øyeblikket de ble med i chatten?",
  check_selected_settings:
    "Vennligst sjekk innstillingene for chatthistorikk for alle valgte brukere!",
  chat_from_start_have:
    "Du har blitt med i denne gruppen. Chatthistorikken har blitt delt.",
  chat_from_start_has:
    "har blitt med i denne gruppen. Chatthistorikken har blitt delt.",
  Address: "Adresse",
  read_by: "Lest av",
  deliver_to: "Levert til",
  remaining: "gjenstående",
  message_info: "Meldingsinfo",
  request_to_join_only: "Forespørsel om å bli med",
  unfollow: "Slutt å følge",
  company_username: "Brukernavn",
  month: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Des",
  ],
  remove_my_admin_right: "Fjern mine administratorrettigheter",
  makeEmp: "Vil du virkelig fjerne firmaadministratorrettigheter fra brukeren?",
  remove_my_self:
    "Vil du virkelig fjerne firmaadministratorrettigheter fra kontoen din?",
  makeAdmin: "Vil du virkelig gi brukeren firmaadministratorrettigheter?",
  remove_member: "Fjern medlem",
  remove_following_confirm: "Vil du virkelig fjerne {name} fra listen over fulgte?",
  remove_follower_confirm: "Vil du virkelig fjerne {name} fra dine følgere? Hvis du fjerner ham/henne vil han/hun ikke bli informert.",
  do_you_really_want_to_remove:
    "Vil du virkelig fjerne brukernavnet fra firmaet?",
  invite_all: "Inviter alle medlemmer av firmaet",
  invite_all_members: "Inviter alle medlemmer",
  mems: "Alle andre medlemmer",
  dep_loc: "Avdeling/Plassering/Lag",
  depAdmin: "Avdelingsadministrator",
  add_remove_admin: "Legg til/Fjern firmaadministratorstilling",
  add_remove_dep_admin: "Legg til/Fjern avdelingsadministratorstilling",
  remove_employees_dept: "Fjern ansatte fra",
  want_to_join_dep:
    "Brukernavn ønsker å bli med i Avdelingen/Plasseringen/Laget depname av firmaet companyname.",
  you_invited:
    "Du har blitt invitert til å bli med i Avdelingen/Plasseringen/Laget depname av firmaet companyname.",
  dep_remove:
    "Vil du virkelig fjerne administratorrettigheter for avdeling eller plassering fra brukeren?",
  add_dep:
    "Vil du virkelig gi brukeren administratorrettigheter for avdelingen eller plasseringen?",
  my_self_dep_remove:
    "Vil du virkelig fjerne avdelingsadministratorrettigheter fra kontoen din?",
  member: "Medlem",
  admin: "Administrator",
  remove_project_admin:
    "Vil du virkelig fjerne medlemmet fra prosjektet?",
  remove_my_self_project: "Vil du virkelig fjerne administratorrettigheter?",
  remove_member_admin_right:
    "Vil du virkelig fjerne administratorrettigheter fra brukeren?",
  add_member_admin_right: "Vil du virkelig legge til administratorrettigheter til brukeren?",
  add_remove_Poss: "Legg til/Fjern administratorstilling",
  forward: "Videresend",
  edit: "Rediger",
  only_kjuup_plus_can: "Kun Kjuup+ firmaer kan publisere artikler.",
  add_images: "Legg til bilde(r)",
  request_confirmation: 'Ventende prosjektinvitasjoner',
  Activity: "Aktivitet",
  latest_messages: "Siste meldinger",
  hours: "timer",
  minute: "minutter",
  seconds: "sekunder",
  days: "dager",
  yesterday: "i går",
  last_week: "forrige uke",
  next_week: "neste uke",
  Last_month: "forrige måned",
  All: "Alle",
  register_plus: "Registrering Plus",
  select_files: "Velg filer",
  monthsFullName: [
    "Januar",
    "Februar",
    "Mars",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Desember",
  ],
  company_deploc_receivers_message:
    "Invitasjonslenke til avdelingen av firmaet firmasnavn i Kjuup. Vennligst klikk på lenken for å registrere deg for Kjuup og bli med i firmaet firmasnavn.",
  no_news: "Ingen nyheter tilgjengelig",
  reminder: "Påminnelse",
  np_reminder: "Ingen oppgaver",
  move_to_reminder: "Flytt til oppgave",
  remove_reminder: "Vil du virkelig fjerne denne meldingen fra listen over dine oppgaver?",
  remove_all_reminder: "Fjern alle oppgaver",
  remove_all_confirm: "Vil du virkelig fjerne alle meldinger fra listen over dine oppgaver?",
  remove_from_reminder: "Fjern fra påminnelse",
  prevent_email: "E-post kan ikke brukes som Brukernavn.",
  allow_noti: "Vennligst tillat varsler.",
  join_cap: "Bli med",
  pass_minimum:
    "**Passord krever 12 tegn inkl. liten bokstav, stor bokstav, tall og spesialtegn.",
  pass_error: "Vennligst sjekk passordkravene",
  people_that_like_article: "Folk som liker artikkelen.",
  people_who_like_article: "Folk som liker din artikkel.",
  message_delete: "Denne meldingen har blitt slettet.",
  message_edited: "redigert",
  edit_message: "Rediger melding",
  edit_window_expired: "Meldinger kan bare redigeres innen 10 minutter etter sending.",
  message_edit_save: "Lagre",
  copy: "Kopier",
  bookmark: "Bokmerke",
  add_reaction: "Legg til reaksjon",
  delete_message: "Slett melding",
  more_options: "Flere alternativer",
  info: "Info",
  link_invite: "Inviter via lenke",
  ll_nkk: "Inviter til Kjuup",
  selected: "Valgt",
  is_active: "Aktiv",
  inactive: "Inaktiv",
  last_online: "sist pålogget {{when}}",
  remove_user_l: "Fjern",
  link_expire: "Hver generert lenke vil være gyldig i 72 timer.",
  company_language: "Firmaspråk",
  company_language_info:
    "Språkvalget vil bli brukt for alle e-postbekreftelser angående firmaet.",
  s_image: "bilde",
  m_image: "bilder",
  removeMsg: "Trykk for å fjerne",
  block: 'Blokker',
  unblock: 'Opphev blokkering',
  blocks: 'Er du sikker på at du vil blokkere denne brukeren?',
  unblocks: 'Er du sikker på at du vil oppheve blokkeringen av denne brukeren?',
  bolcked_click_un_block:
    'Du har blokkert denne kontakten. Klikk her for å fjerne blokkeringen.',
  you_have_unblocked: 'Du har opphevet blokkeringen av denne kontakten.',
  you_have_blocked: 'Du har blokkert denne kontakten.',
  unblock_to_send: 'Opphev blokkering av bruker for å sende melding.',
  pilot_text: "Spesialisert AI for byggetemaer",
  startup_screen_label: "Startskjerm",
  startup_screen_info: "Velg hvilken skjerm som åpnes når Kjuup starter.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Meldinger",
  startup_screen_saved: "Startskjerm oppdatert",
email_on: "E-postvarsler for chatter",
  email_on_grp: "E-postvarsel",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Aktiver eller deaktiver e-postvarsler for dette prosjektet. Dette alternativet er kun tilgjengelig når \"E-postvarsler for chatter\" er aktivert via personlige innstillinger.",
  todo_notification_info: "Du blir varslet hver gang en ny oppgave blir tildelt deg.",
  info_val: "Du får en e-post hvis en ny chattemelding ikke leses innen kort tid. Du kan slå det av for enkelte prosjekter eller chatter i innstillingene deres eller i chattegruppens info.",
  email_groups: "Aktiver eller deaktiver e-postvarsler for denne chatten. Dette alternativet er kun tilgjengelig når \"E-postvarsler for chatter\" er aktivert via personlige og prosjektinnstillinger.",
  add_update_email: "Legg til/Oppdater e-post",
  text_to_verifiy: "Alternativet \"E-postvarsler for chatter\" kan kun aktiveres hvis du har en bekreftet e-postadresse i filen.",
  stored_email: "Lagret e-post: ",
  verify_email: "Bekreftelse venter!",
  join_call:"Bli med",
  call_is_started:"Samtale er startet",
  start_chat:"Start direktechat?",
  project_rooms:"Prosjekter",
  download_selected:"Last ned",
  add_employee_confirm: 'Er du sikker på at du vil legge til denne brukeren i firmaet?',
  invalid_deeplink: "Ugyldig dyp lenke-URL. Manglende påkrevde parametere.",
  deeplink_error: "Kan ikke behandle dyp lenke. Vennligst prøv igjen senere.",
  // Reply functionality translations
  reply: "Svar",
  reply_enter: "Skriv inn svar...",
  reply_sent_successfully: "Svar sendt vellykket",
  reply_failed: "Kunne ikke sende svar",
  reply_failed_generic: "Kunne ikke sende svar. Vennligst prøv igjen.",
  replying_to_message: "Svarer på melding",
  cancel_reply: "Avbryt svar",
  voice_message: "Stemmemelding",
  send: "Send",
  cancel: "Avbryt",
  type_your_reply: "Skriv ditt svar...",
  
  // Auto-suggestion translations
  suggested_replies: "Foreslåtte svar",
  suggestions_error: "Kunne ikke laste forslag",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Bilde — Klikk for å laste",
  lazy_media_audio: "Talemelding — Klikk for å laste",
  lazy_media_doc: "Dokument — Klikk for å laste",
  lazy_media_video: "Video — Klikk for å laste",
  suggestion_loading_message: "Et øyeblikk. Teksten din forberedes individuelt for deg.",
  loading_chat_message: "Laster chat...",
  
  // Manual ToDo translations
  extracting_message: "Henter ut melding...",
  create_todo: "Opprett oppgave",
  create_todo_confirmation: "Vil du opprette en oppgave fra denne meldingen?",
  select_project_required: "Vennligst velg et prosjekt/gruppe",
  only_assigned_can_change_status: "Kun tildelte brukere kan endre status",
  todo_summary: "Sammendrag",
  todo_summary_placeholder: "Skriv inn oppgavesammendrag...",
  todo_date: "Dato",
  todo_time: "Tid",
  todo_date_hint: "La stå tomt for å bruke originalt meldingsdato/tid",
  todo_created_success: "Oppgave opprettet vellykket",
  todo_creation_failed: "Kunne ikke opprette oppgave",
  create: "Opprett",
  
  image: "bilde",
  images: "bilder",
  remove_all_images: "Fjern alle bilder",
  remove_image: "Fjern bilde",
  remove_document: "Fjern dokument",
  remove_recording: "Fjern opptak",
  play_recording: "Spill av opptak",
  upload_image: "Last opp bilde",
  upload_document: "Last opp dokument",
  record_audio: "Ta opp lyd",
  stop_recording: "Stopp opptak",
  stop_recording_text: "Stopp opptak",
  please_remove_current_attachment: "Vennligst fjern nåværende vedlegg for",
  please_upload_image_file: "Vennligst last opp en gyldig bildefil",
  please_upload_valid_document: "Vennligst last opp en gyldig dokumentfil",
  searching_messages: "Søker meldinger...",
  loading_more: "Laster mer...",
  loading_more_users: "Laster flere brukere...",
  load_more_users: "Last flere brukere",
  no_more_users_to_load: "Ingen flere brukere å laste",
  no_messages_found: "Ingen meldinger funnet",
  try_different_keyword: "Prøv et annet nøkkelord eller sjekk stavemåten din.",
  search_messages: "Søk meldinger, chattegrupper, prosjekter og brukere...",
  todo: "Oppgave",
  np_todo: "Ingen oppgaver",
  move_to_todo: "Lagre som oppgave",
  remove_todo: "Vil du virkelig fjerne oppgaven?",
  remove_all_todo: "Fjern alle oppgaver",
  remove_all_todo_confirm: "Vil du virkelig fjerne alle oppgaver?",
  add_to_todo: "Legg til i oppgave",
  remove_from_todo: "Fjern fra oppgave",
  confirm: "Bekreft",
  ok: "Ok",
  read_more: "Les mer",
  show_less: "Vis mindre",
  show_more: "Vis mer",
  audio: "Lyd",
  video: "Video",
  // Notification Settings
  notification_schedule: "Varselplan",
  notification_schedule_desc: "Du vil kun motta push- og e-postvarsler i timene du velger. Utenfor disse tidene settes de på pause.",
  learn_more: "Lær mer",
  allow_notifications: "Tillat varsler:",
  every_day: "Hver dag",
  weekdays: "Ukedager (mandag til fredag)",
  custom: "Tilpasset",
  monday: "Mandag",
  tuesday: "Tirsdag",
  wednesday: "Onsdag",
  thursday: "Torsdag",
  friday: "Fredag",
  saturday: "Lørdag",
  sunday: "Søndag",
  to: "til",
  notification_settings: "Varsler",
  notification_settings_saved: "Varselinnstillinger lagret vellykket",
  notification_settings_error: "Kunne ikke lagre varselinnstillinger",
  unavailability_note: "Fraværsmelding",
  unavailability_description: "Sett en fraværsmelding. Mens den er aktiv, vises meldingen for andre i alle chattene dine, og varsler settes på pause.",
  unavailability_start_date: "Startdato",
  unavailability_end_date: "Sluttdato",
  unavailability_message: "Melding",
  unavailability_message_hint: "Bruk {endDate} som plassholder for din returdato.",
  unavailability_replacement: "Erstatningskontakt",
  unavailability_replacement_placeholder: "Skriv inn bruker-ID for hastesaker",
  unavailability_replacement_current: "Nåværende erstatning",
  unavailability_replacement_hint: "Hvis satt, vises en lenke for å kontakte denne personen for hastesaker i fraværsmeldingen din.",
  unavailability_replacement_none: "Ingen erstatning (valgfritt)",
  unavailability_contact_urgent: "For hastesaker kontakt",
  unavailability_default_message: "Jeg er for tiden ikke på kontoret og har ikke tilgang til Kjuup. Jeg er tilgjengelig igjen fra {endDate} og tar kontakt da.",
  unavailability_save: "Lagre",
  unavailability_deactivate: "Deaktiver",
  unavailability_active_until: "Aktiv til",
  unavailability_saved: "Fraværsmelding lagret",
  unavailability_save_error: "Kunne ikke lagre fraværsmelding",
  unavailability_deactivated: "Fraværsmelding deaktivert",
  unavailability_end_date_required: "Sluttdato er påkrevd",
  start_time_before_end_time: "Starttid må være før sluttid",
  loading: "Laster",
  disabled: "Deaktivert",
  enable: "Aktiver",
  disable: "Deaktiver",
  forwarded: "Videresendt",
  message_forwarded: "Melding videresendt!",
  // Schedule Article
  schedule_article_post: "Planlegg artikkelpublisering",
  date: "Dato",
  time: "Tid",
  scheduled_for_publication: "Planlagt for publisering",
  article_will_be_published_on: "Artikkelen vil bli publisert:",
  reset_selection: "Tilbakestill valg",
  continue: "Fortsett",
  cancel: "Avbryt",
  // Member Selection
  error_loading_members: "Feil ved lasting av medlemmer",
  please_fill_all_fields: "Vennligst fyll ut alle felt",
  invalid_email: "Ugyldig e-postadresse",
  member_added_successfully: "Medlem lagt til vellykket",
  error_onboarding_user: "Feil ved tillegg av bruker",
  error_creating_chat: "Feil ved opprettelse av chat",
  error_creating_group: "Feil ved opprettelse av gruppe",
  new_group: "Ny gruppe",
  please_select_or_enter_group_name: "Vennligst velg en gruppe eller skriv inn et gruppenavn",
  please_select_or_enter_room_name: "Vennligst velg et prosjekt eller skriv inn et prosjektnavn",
  error_creating_room: "Feil ved opprettelse av prosjekt",
  error_opening_chat: "Feil ved åpning av chat",
  privacy_modal_text: "Velg \"Privat\" kun hvis chatten ikke inneholder relevant profesjonelt innhold for prosjektlederen.",
  not_private: "Ikke privat",
  private: "Privat",
  error_loading_groups: "Feil ved lasting av grupper",
  automatic_chat_export: "Automatisk chatteksport",
  automatic_chat_export_info: "Etter aktivering vil chatthistorikken automatisk bli sendt til den angitte e-postadressen hver måned.",
  automatic_chat_export_no_email: "For å aktivere automatisk chatteksport må du først legge til en e-postadresse. Du kan legge til e-postadressen din i de personlige innstillingene.",
  enter_email: "Skriv inn e-post",
  update: "Oppdater",
  confirm: "Bekreft",
  export_to_email: "Eksporten går til følgende e-post.",
  start_chat_button:"Ny melding",
  matching_existing_chats: "Matchende eksisterende chatter",
  subject: "Emne",
  add_subject: "Legg til emne",
  chat_subject: "Chattemne:",
  set_project_room: "Angi prosjekt",
  matching_existing_project_rooms: "Matchende eksisterende prosjekter",
  name_project_room: "Gi navn til prosjekt",
  professional_or_private: "Profesjonelt eller privat",
  professional: "Profesjonelt",
  privacy_modal_text_updated: "Velg \"Privat\" kun hvis chatten ikke inneholder relevant profesjonelt innhold for prosjektledere. Private chatter er ikke synlige for prosjektledere.",
  create_internal_chat: "Ekstern - eller intern chat?",
  internal_chat_description: "Kun ansatte i firmaet ditt kan legges til i interne chatter.",
  yes: "Ja",
  no: "Nei",
  chat_is_being_created: "Chatten opprettes...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Vil du virkelig forkaste endringene i denne artikkelen?",
  please_enter_article_title: "Vennligst skriv inn artikkeltittel først.",
  please_add_mandatory_fields: "Vennligst legg til alle obligatoriske felt",
  product_label: "Produkt:",
  no_companies_found: "Ingen firmaer funnet",
  visible_to_all_followers: "Synlig for alle Kjuup-medlemmer",
  only_visible_to_employees: "Synlig kun for ansatte",
  something_went_wrong: "Noe gikk galt, vennligst prøv igjen",
  please_select_department: "Vennligst velg avdeling/plassering",
  schedule: "Planlegg",
  please_select_future_date_time: "Vennligst velg en fremtidig dato og tid for å planlegge artikkelen.",
  please_select_different_date_time: "Vennligst velg en annen dato eller tid for å planlegge artikkelen.",
  please_select_later_time: "Vennligst velg en tid senere enn nåværende tid for i dag.",
  unpin_article: "Løsne artikkel",
  pin_article: "Fest artikkel",
  and: "og",
  others: "andre",
  at: "på",
  // Chat mute/unmute translations
  mute: "Demp",
  unmute: "Slå av demping",
  chat_muted_successfully: "Chatten dempet vellykket",
  chat_unmuted_successfully: "Chatten demping avslått vellykket",
  mute_chat_confirm: "Vil du virkelig dempe denne chatten? Du vil ikke lenger motta varsler for nye meldinger.",
  unmute_chat_confirm: "Vil du virkelig slå av dempingen av denne chatten? Du vil motta varsler for nye meldinger igjen.",
  please_select_group_to_forward: "Vennligst velg gruppe for å videresende melding",
  // Company translations
  record_not_found: "Post ikke funnet!",
  please_select_position: "Vennligst velg stilling",
  delete_article_confirm: "Er du sikker på at du vil slette denne artikkelen?",
  delete_company_service_confirm: "Er du sikker på at du vil slette firmas tjeneste?",
  block_translation_confirm: "Vil du virkelig blokkere automatisk oversettelse i prosjekter for alle medlemmer av firmaet",
  unblock_translation_confirm: "Vil du virkelig oppheve blokkeringen av automatisk oversettelse i prosjekter for alle medlemmer av firmaet",
  please_select_file: "Vennligst velg en fil å laste opp",
  role_in_building_industry: "Rolle i byggebransjen*",
  invalid_email_address: "Ugyldig e-postadresse",
  please_enter_password: "Vennligst skriv inn passord",
  password_change_email_sent: "En e-post er sendt til din Kjuup e-post. Bekreft ditt nye passord ved å klikke på bekreftelseslenken i e-posten.",
  please_enter_username: "Vennligst skriv inn brukernavn",
  username_same_as_before: "Brukernavnet kan ikke være det samme som før",
  profile_deleted_successfully: "Profil slettet vellykket",
  hardware_requirements: "Maskinvarekrav",
  hardware_requirements_list: "• 4GB RAM<br/>• CPU-hastighet min. 2GHz<br/>• Windows 7 eller høyere / alle macOS-versjoner",
  submitting: "Sender...",
  signing_in: "Logger inn...",
  please_enter_service_name: "Vennligst skriv inn tjenestenavn",
  something_went_wrong_error: "Aaaah! Noe gikk galt...",
  something_went_wrong_try_again: "Beklager, noe gikk galt der. Prøv igjen",
  position_label: "Stilling:",
  loading_room: "Laster prosjekt...",
  navigating_to_room: "Navigerer til prosjektet",
  loading_chat: "Laster chat...",
  translate: "Oversett",
  show_original: "Vis original",
  saving: "Lagrer...",
  language_selection_info: "Språkvalget brukes for alle e-postbekreftelser relatert til firmaet.",
  // Navigation bar labels
  nav_call: "Ring",
  nav_home: "Hjem",
  nav_messages: "Meldinger",
  nav_todo: "Oppgaver",
  nav_rooms: "Prosjekter",
  nav_all_rooms: "Alle prosjekter",
  pinned_rooms_max: "Du kan feste opptil 10 prosjekter.",
  pinned_room_unpin: "Løsne",
  pinned_rooms_drop: "Dra prosjektet hit for raskt valg",
  nav_profile: "Profil",
  nav_company: "Firma",
  nav_company_documents: "Dokumenter",
  nav_logout: "Logg ut",
  // Create message dialog
  add_member_title: "Legg til medlem",
  continue_btn: "Fortsett",
  search_placeholder: "Søk",
  no_members_found: "Ingen medlemmer funnet",
  no_groups_found: "Ingen grupper funnet",
  no_rooms_found: "Ingen prosjekter funnet",
  search_users_tab: "Brukere",
  search_documents_tab: "Dokumenter",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Ingen filer",
  no_documents_available: "No documents",
  searching_users: "Søker etter brukere...",
  no_users_found: "Ingen brukere funnet",
  search_emails_tab: "E-post",
  searching_emails: "Søker etter e-poster...",
  no_emails_found: "Ingen e-poster funnet",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Navnløs gruppe",
  unnamed_room: "Navnløst prosjekt",
  all_members: "Alle",
  room_label: "Prosjekt:",
  subject_label: "Emne:",
  no_members: "Ingen medlemmer",
  // Loading states for room creation
  creating_structure: "Oppretter din struktur",
  opening_chat: "Åpner chatten",
  please_wait: "Vennligst vent...",
  // ToDo page translations
  loading_todo: "Laster ToDo...",
  task_updated: "Oppgave oppdatert",
  error_updating_task: "Feil ved oppdatering av oppgave",
  task_deleted: "Oppgave slettet",
  error_deleting_task: "Feil ved sletting av oppgave",
  delete_task_confirm: "Er du sikker på at du vil slette denne oppgaven?",
  description_label: "Beskrivelse",
  description_placeholder: "Skriv inn beskrivelse...",
  date_time_label: "Dato & Tid",
  save_hint: "Ctrl+Enter for å lagre, Esc for å avbryte",
  edit_label: "Rediger",
  delete_label: "Slett",
  todo_list_title: "Oppgaver",
  tasks_count: "oppgaver",
  search_placeholder_todo: "Søk...",
  select_task_to_open_chat: "Velg en oppgave for å åpne chatten",
  today: "I dag",
  yesterday: "I går",
  time_suffix: "", // Empty for Norwegian (24h format doesn't need suffix)
  from_chat: "Kildeoppgave",
  assigned_to: "Tildelt til",
  assign_users: "Tildel brukere",
  no_users_assigned: "Ingen brukere tildelt",
  assign: "Tildel",
  assign_to: "Tildel til...",
  navigate_to_chat: "Naviger til chat",
  navigate_to_email: "Gå til e-post",
  show_original_message: "Vis kilde",
  hide_original_message: "Skjul kilde",
  status_pending: "Venter",
  status_in_progress: "Pågår",
  status_completed: "Fullført",
  show: "Vis",
  close: "Lukk",
  status_confirmed: "Bekreftet",
  log_todo_created: "Oppgave opprettet",
  log_todo_confirmed: "Oppgave bekreftet",
  log_todo_deleted: "Oppgave slettet",
  log_todo_updated: "Oppgave oppdatert",
  log_description_updated: "Beskrivelse oppdatert",
  log_deadline_updated: "Frist oppdatert",
  log_assigned_to: "Tildelt til {name}",
  log_unassigned_from: "Fjernet fra {name}",
  log_assignment_added: "Tildeling lagt til: {name}",
  log_assignment_removed: "Tildeling fjernet: {name}",
  log_status_updated: "Status endret fra {from} til {to}",
  log_status_changed: "Status endret",
  log_status_changed_to: "Status endret til {status}",
  log_changed_status_to: "Endret statusen til:",
  log_for_user: "for bruker:",
  log_user_updated_status: "Bruker oppdaterte sin oppgavestatus",
  log_changed_date_to: "Endret datoen til:",
  log_changed_description_to: "Endret beskrivelsen til:",
  log_moved_to: "Flyttet til {status}",
  todo_status_updated_from: "fra",
  todo_status_updated_to: "til",
  filter_pending: "Ventende",
  filter_confirmed: "Bekreftet",
  filter_assigned_to_me: "Mine oppgaver",
  filter_assigned_by_me: "Delegert",
  todo_project_label: "Prosjekt:",
  assigned_users: "Tildelte brukere:",
  todo_chat_label: "Chat:",
  history: "Historikk",
  todo_assigned_by: "Tildelt av:",
  todo_assigned_push: "Tildelt ToDo:",
  todo_assigned_push_empty: "En ny ToDo er tildelt deg.",
  search_groups: "Grupper",
  search_chat_groups: "Chatgrupper",
  search_project_room: "Prosjekt",
  search_messages_tab: "Meldinger",
  searching_groups: "Søker etter grupper...",
  searching_rooms: "Søker etter prosjekter...",
  no_groups_found: "Ingen grupper funnet",
  no_rooms_found: "Ingen prosjekter funnet",
  create_poll: "Avstemning",
  poll_question_label: "SPØRSMÅL",
  poll_question_placeholder: "Still et spørsmål",
  poll_options_label: "ALTERNATIVER",
  poll_option: "Alternativ",
  poll_add_option: "Legg til alternativ",
  poll_allow_multiple: "Tillat flere svar",
  poll_multiple_allowed: "Velg ett eller flere alternativer",
  poll_select_option: "Velg ett alternativ",
  poll_view_votes: "Se stemmer",
  poll_vote_singular: "stemme",
  poll_vote_plural: "stemmer",
  poll_votes: "Avstemningsresultat",
  poll_no_votes_yet: "Ingen stemmer ennå",
  transcript_step_processing: "Transkripsjon pågår...",
  ai_transcript_tab: "AI-Transkripsjon",
  ai_transcript_info: "Kun tilgjengelig for talemeldinger opprettet etter 09.03.2026.",
  transcript_more: "...mer",
  transcript_less: "...mindre",
  ki_transcript_voice_message: "KI-Transkripsjon av talemelding",
  ki_image_analysis: "AI-støttet bildeanalyse",
  type_message: "Skriv en melding",
  email_tab_messages: "Meldinger",
  email_tab_email: "E-post",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "E-postkontoer",
  email_connect_gmail: "Koble til Gmail",
  email_connect_outlook: "Koble til Outlook",
  email_no_accounts: "Ingen e-postkontoer koblet til",
  email_no_accounts_hint: "Koble til en e-postkonto i profilinnstillingene",
  email_no_messages: "Ingen e-poster",
  email_from: "Fra",
  email_to: "Til",
  email_subject: "Emne",
  email_disconnect: "Koble fra",
  email_disconnect_confirm: "Er du sikker på at du vil koble fra denne e-postkontoen? Alle synkroniserte e-poster vil bli fjernet.",
  email_account_disconnected: "E-postkontoen er frakoblet",
  email_account_disconnect_failed: "Kunne ikke koble fra kontoen",
  email_connecting: "Kobler til...",
  email_account_connected: "Konto koblet til vellykket",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Gå til innstillinger",
  email_date: "Dato",
  email_reply: "Svar",
  email_forward: "Videresend",
  email_copy_text: "Kopier tekst",
  email_text_copied: "Kopiert!",
  email_text_copy_failed: "Teksten kunne ikke kopieres.",
  email_delete: "Slett",
  email_not_spam: "Ikke spam",
  email_not_spam_success: "E-post flyttet til innboks.",
  email_not_spam_failed: "Kunne ikke flytte til innboks.",
  email_delete_confirm: "Er du sikker på at du vil slette denne e-posten?",
  email_delete_from_folder: "Er du sikker på at du vil slette fra {folder}?",
  email_delete_permanent_from_folder:
    "Er du sikker på at du vil slette permanent fra {folder}? Denne handlingen kan ikke angres.",
  email_save_draft_confirm: "Vil du lagre denne e-posten som utkast?",
  email_save_draft: "Lagre utkast",
  email_discard: "Forkast",
  email_back_to_compose: "Tilbake til skriving",
  email_draft_saved: "Utkast lagret.",
  email_draft_save_failed: "Kunne ikke lagre utkast.",
  email_loading: "Laster e-poster...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Velg",
  email_attachment_singular: "Vedlegg",
  email_attachment_plural: "Vedlegg",
  email_back: "Tilbake",
  email_download: "Last ned",
  email_close: "Lukk",
  email_preview: "Forhåndsvisning",
  email_preview_not_available: "Forhåndsvisning er ikke tilgjengelig",
  email_preview_failed: "Forhåndsvisning er ikke tilgjengelig",
  select_attachments: "Velg vedlegg",
  email_loading_preview: "Laster forhåndsvisning...",
  email_mark_unread_failed: "e-post(er) kunne ikke merkes som ulest.",
  email_delete_failed: "e-post(er) kunne ikke slettes.",
  filter_all: "Alle",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Direkte meldinger",
  my_notes: "My Space",
  filter_internal_groups: "Interne gruppechatter",
  filter_external_groups: "Eksterne gruppechatter",
  filter_group_chats: "Gruppechatter",
  filter_groups_internal: "Interne",
  filter_groups_external: "Eksterne",
  filter_unread_only: "Kun uleste",
  room_daily_briefing_info: "Når den er aktivert, genereres en rapport for dette prosjektet hver 24. time på tidspunktet angitt i dine personlige innstillinger — men bare hvis det har vært aktivitet i den perioden.",
  email_select_all: "Velg alle",
  email_deselect_all: "Fjern alle valg",
  email_reply_all: "Svar alle",
  email_reply_placeholder: "Skriv ditt svar...",
  email_forward_placeholder: "Legg til en melding...",
  email_edit_draft: "Rediger utkast",
  email_attach: "Legg ved",
  email_attachment_from_original: "Fra opprinnelig melding",
  email_remove: "Fjern",
  email_drop_files: "Slipp filer for å legge ved",
  email_loading_attachments: "Laster vedlegg...",
  email_archive: "Arkiver",
  mark_unread: "Merk som ulest",
  mark_read: "Merk som lest",
  email_all_accounts: "Alle kontoer",
  email_error: "Feil",
  email_delete_email_failed: "Kunne ikke slette e-post.",
  enter_url: "Skriv inn URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Abonner nå',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 MÅNEDS GRATIS PRØVEPERIODE',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Ingen betaling i dag. Kredittkortdetaljer blir ikke bedt om før det betalte abonnementet starter.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Administrer alle e-postkontoer direkte i Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'AI skriver svar – du bekrefter bare',
  kjuup_io_feature_tasks: 'Oppgaver og kalender alltid automatisk oppdatert',
  kjuup_io_choose_plan: 'Velg plan',
  kjuup_io_plan_monthly: 'Månedlig',
  kjuup_io_plan_yearly: 'Årlig',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Sikret av Stripe · kan sies opp når som helst',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Betaling mottatt. Abonnementet ditt aktiveres…',
  kjuup_io_toast_activating_soon: 'Betaling mottatt. Abonnementet ditt aktiveres snart.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: '{count} timer igjen',
  kjuup_io_trial_left_hour: '1 time igjen',
  kjuup_io_trial_left_minutes: '{count} minutter igjen',
  kjuup_io_trial_left_minute: '1 minutt igjen',
  kjuup_io_trial_left_seconds: '{count} sekunder igjen',
  kjuup_io_trial_left_second: '1 sekund igjen',
  kjuup_io_trial_ending_now: 'Prøveperioden din avsluttes…',
  kjuup_io_request_timeout: 'Tilkoblingen ble tidsavbrutt. Prøv igjen.',
  kjuup_io_info_days_free: '{days} dager helt gratis – abonnementet starter først etter prøveperioden.',
  kjuup_io_discount_total: 'Din rabatt: {percent} %',
  kjuup_io_discount_company: '{company}: {percent} %',
  kjuup_io_discount_personal: 'Personlig: {percent} %',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Lukk',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Den gratis prøveperioden din er over',
  kjuup_io_trial_ended_body: 'Abonner på Kjuup.io for å fortsette å bruke e-post og andre premiumfunksjoner.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Den gratis prøveperioden din har startet',
  kjuup_io_toast_trial_fail: 'Kunne ikke starte prøveperioden',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / måned',
  kjuup_io_save_amount_year: 'Spar {price} per år',
  kjuup_io_billed_annually_amount: '{price} faktureres årlig',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Dette får du:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Ingen kredittkort nødvendig – start med en gang uten betalingsopplysninger.',
  kjuup_io_info_cancel_anytime: 'Si opp når som helst – ingen binding, ingen risiko.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Faktureringsperiode',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Betalingsmåte lagret. Du blir belastet når prøveperioden er over.',
  calendar_sync_info: 'Synkroniser automatisk alle Kjuup ToDos med kalenderen din.',
  calendar_no_accounts: 'Ingen kalender er koblet til ennå.',
  article_new_badge: 'NY',
  article_new_posts: '{0} nye innlegg',
  documents: 'Dokumenter',
  add_documents: 'Legg til dokumenter',
  no_preview_available: 'Ingen forhåndsvisning tilgjengelig',
  no_preview_hint: 'Denne filtypen kan ikke forhåndsvises, men den sendes likevel.',
  max_documents_reached: 'Du kan legge ved opptil 10 dokumenter om gangen.',
  open_file: 'Åpne fil',
  twofa_title: 'Tofaktorautentisering',
  twofa_method_totp: 'Autentiseringsapp',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'E-post',
  twofa_enter_app: 'Skriv inn den 6-sifrede koden fra autentiseringsappen.',
  twofa_enter_sms: 'Skriv inn den 6-sifrede koden vi sendte på SMS.',
  twofa_enter_email: 'Skriv inn den 6-sifrede koden vi sendte til e-posten din.',
  twofa_resend: 'Send koden på nytt',
  twofa_try_another: 'Prøv en annen metode',
  twofa_remember_device: 'Ikke spør på denne enheten i 30 dager',
  twofa_sent: 'Vi har sendt en kode.',
  twofa_invalid_code: 'Koden er feil. Prøv igjen.',
  twofa_something_wrong: 'Noe gikk galt. Prøv igjen.',
  twofa_method_unavailable: 'Den metoden er ikke tilgjengelig.',
  twofa_on_desc: 'Tofaktorautentisering er på. Du trenger en kode hver gang du logger inn.',
  twofa_off_desc: 'Legg til et andre trinn etter passordet. Autentiseringsapper er mest sikkert.',
  twofa_methods: 'Metoder',
  twofa_on: 'På',
  twofa_add: 'Legg til',
  twofa_default_method: 'Standardmetode',
  twofa_default: 'Standard',
  twofa_turn_off: 'Slå av',
  twofa_disable_hint: 'Skriv inn passordet og en gjeldende kode for å slå av tofaktorautentisering.',
  twofa_disable_need: 'Skriv inn passordet og en bekreftelseskode.',
  twofa_code_placeholder: '6-sifret kode eller reservedkode',
  twofa_send_code: 'Send en kode',
  twofa_primary_updated: 'Standardmetoden er oppdatert.',
  twofa_disabled: 'Tofaktorautentisering er nå slått av.',
  twofa_enabled: 'Tofaktorautentisering er nå slått på.',
  twofa_totp_help: 'Skann denne QR-koden med Google Authenticator, Authy eller 1Password. Du kan også skrive inn nøkkelen manuelt.',
  twofa_secret_copied: 'Nøkkelen er kopiert',
  twofa_sms_help: 'Oppgi nummeret i internasjonalt format. Vi sender en 6-sifret kode på SMS.',
  twofa_email_help: 'Vi sender en 6-sifret kode til e-postadressen på kontoen din.',
  twofa_backup_title: 'Reservedkoder',
  twofa_backup_help: 'Lagre disse engangskodene på et trygt sted. Hver kode kan brukes én gang hvis du mister telefonen.',
  twofa_copy_codes: 'Kopier koder',
  twofa_codes_copied: 'Reservedkodene er kopiert',
  twofa_regenerate: 'Få nye reservedkoder',
  twofa_regenerate_hint: 'Dette erstatter ubrukte reservedkoder. Skriv inn passordet og en gjeldende kode.',
  twofa_backup_remaining: '{n} ubrukte reservedkoder igjen',
  twofa_new_codes: 'Nye reservedkoder',
  twofa_sms_unavailable: 'SMS-koder er ikke tilgjengelige ennå.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Tildelte Kjuup-oppgaver kopieres til et prosjekt kalt Kjuup i Todoist. Endringer i Todoist kopieres ikke tilbake.",
  todoist_connect: "Koble til Todoist",
  todoist_connected: "Todoist er tilkoblet",
  todoist_connect_failed: "Klarte ikke å koble til Todoist",
  todoist_disconnect: "Koble fra",
  todoist_disconnected: "Todoist er frakoblet",
  todoist_disconnect_confirm: "Koble fra Todoist? Oppgaver som allerede ligger i Todoist blir værende. Synkroniseringen stopper.",
  todoist_sync_now: "Synkroniser nå",
  todoist_syncing: "Synkroniserer…",
  todoist_sync_done: "Synkronisering fullført",
  todoist_sync_failed: "Synkronisering mislyktes",
  todoist_auth_error: "Koble til Todoist på nytt for å fortsette synkroniseringen.",
  todoist_last_sync: "Siste synkronisering",
  todoist_not_connected: "Todoist er ikke tilkoblet",
  todoist_auth_url_failed: "Kunne ikke åpne Todoist-autorisasjonssiden.",
  recommend_text: "Bli med i Kjuup for å holde kontakten og holde orden på kommunikasjonen din. Samle kanalene dine, hold meldingene i riktige prosjekter og start hver morgen med et sammendrag og oppgavene dine – alt synkronisert med appene du allerede bruker. Kom i gang gratis:",
  pro_auth_signin_title: 'Velkommen tilbake',
  pro_auth_signin_sub: 'Logg inn med jobb-e-posten din.',
  pro_auth_email_or_username: 'E-post eller brukernavn',
  pro_auth_email_placeholder: 'navn@bedrift.no',
  pro_auth_forgot_password: 'Glemt passord?',
  pro_auth_create_account: 'Opprett konto',
  pro_auth_show_password: 'Vis passord',
  pro_auth_hide_password: 'Skjul passord',
  pro_auth_register_sub: 'Vi sender deg en lenke for å bekrefte e-posten din.',
  pro_auth_register_plus_sub: 'Velg et brukernavn og et passord. Deretter angir du sikkerhets-PIN-en din.',
  pro_auth_check_credentials: 'Sjekk e-posten og passordet ditt',
  pro_news_export_pdf: 'Eksporter som PDF',
  pro_news_pdf_failed: 'PDF-en kunne ikke opprettes.',
  pro_news_pdf_attachments: 'Vedlegg',
  pro_news_pdf_video: 'Video',
  pro_auth_forgot_sub: 'Skriv inn e-posten din, så sender vi deg en lenke for å tilbakestille passordet.',
  pro_auth_send_link: 'Send tilbakestillingslenke',
  pro_auth_plus_reset: 'Tilbakestill med PIN',
  pro_auth_show_pin: 'Vis PIN',
  pro_auth_hide_pin: 'Skjul PIN',
  v2_auth_plus_only: 'Kun Kjuup+',
  room_action_media: "Filer",
  room_tab_overview: "Oversikt",
  room_tab_history: "Historikk",
  chat_info_media: "Filer",
  messages: "meldinger",
  pro_todo_project_required: "Velg et prosjekt",
  pro_todo_choose_project: "Hvilket prosjekt er oppgaven for?",
  cockpit_report_delete_confirm: "Slette denne dagsrapporten?",
  cockpit_report_deleted: "Dagsrapport slettet",
  cockpit_tab_company: "Bedrift",
  cockpit_bookmarked_priorities: "Merkede oppgaver",
  cockpit_load_error: "Cockpit kunne ikke lastes.",
  cockpit_retry: "Prøv igjen",
  cockpit_yesterday: "I går",
  cockpit_greeting_morning: "God morgen",
  cockpit_greeting_day: "God dag",
  cockpit_greeting_evening: "God kveld",
  cockpit_assistant_q_open: "Hva er åpent i dag?",
  cockpit_assistant_q_summarize: "Oppsummer chatten {{room}}",
  cockpit_assistant_q_overdue: "Hvilke oppgaver er forfalt?",
  cockpit_assistant_new: "{{n}} nye",
  cockpit_assistant_important: "{{n}} viktige",
  cockpit_assistant_title: "Kjuup-assistent",
  cockpit_assistant_hint: "Trykk og spør",
  room_overview_priority_no_detail: "Rapporten gir ingen flere detaljer om denne prioriteten.",
  room_overview_priority_from: "Kilde: {{name}}",
  room_overview_priority_open_task: "Åpne oppgave",
  cockpit_priority_position: "{{index}} av {{total}} prioriteringer",
  room_overview_today_title: "Viktig i dag",
  room_overview_all_tasks: "Alle",
  room_overview_tasks_empty: "Ingen åpne frister eller oppgaver",
  room_overview_appointments_empty: "Ingen kommende avtaler",
  room_overview_no_priorities: "Ingen åpne prioriteringer i den siste rapporten.",
  cockpit_report_top5: "Topp 5 prioriteringer",
  cockpit_report_todo_created: "Oppgave opprettet",
  cockpit_report_source_missing: "Kildemeldingen ble ikke funnet.",
  delete_bookmarked_priority_confirm: "Er du sikker på at du vil slette denne merkede oppgaven?",
  cockpit_report_create_todo: "Opprett oppgave",
  cockpit_priorities_deleting: "Sletter …",
  cockpit_priorities_select: "Slett flere",
  cockpit_report_none: "Ingen oppføringer.",
  cockpit_priorities_delete_confirm: "Er du sikker på at du vil slette {count} merkede oppgaver?",
  cockpit_priorities_delete_failed: "{count} oppgaver kunne ikke slettes",
  cockpit_priorities_deleted: "{count} oppgaver slettet",
  cockpit_priorities_selected: "{count} valgt",
  cockpit_channel_connected: "Tilkoblet",
  cockpit_channel_not_connected: "Ikke tilkoblet",
  cockpit_channel_connect: "Koble til",
  cockpit_channel_chat: "Kjuup-chat",
  cockpit_channel_active: "Aktiv",
  cockpit_channel_hidden: "Skjult",
  cockpit_channel_enable: "Aktiver",
  cockpit_channel_email: "E-post",
  cockpit_channel_check: "Kontroller tilkoblingen",
  cockpit_channel_fix: "Kontroller",
  cockpit_channel_forward: "Videresendingsadresse",
  cockpit_channel_not_set_up: "Ikke satt opp",
  cockpit_channel_set_up: "Sett opp",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Tilkoblingen er brutt",
  cockpit_channel_importing: "Importerer",
  cockpit_channel_removing: "Kobler fra",
  cockpit_channel_reconnect: "Koble til på nytt",
  cockpit_channels_title: "Kanaler",
  cockpit_company_role_super_admin: "Firmaadministrator",
  cockpit_company_role_dept_admin: "Avdelingsadministrator",
  cockpit_company_role_member: "Ansatt",
  cockpit_company_none: "Fant ikke noe Kjuup+-firma",
  cockpit_company_eyebrow: "Firma",
  cockpit_company_inactive: "inaktivt",
  cockpit_company_settings: "Firmainnstillinger",
  cockpit_company_employees: "Ansatte",
  cockpit_company_internal_rooms: "Interne prosjekter",
  cockpit_report_all_projects: "Alle prosjekter",
  cockpit_report_progress_emails: "Analyserer e-poster",
  cockpit_report_progress_chats: "Analyserer chatmeldinger",
  cockpit_report_progress_documents: "Analyserer vedlegg og dokumenter",
  cockpit_report_progress_tasks: "Analyserer oppgaver",
  cockpit_report_progress_summarizing: "Analyserer innhold",
  cockpit_report_progress_reading: "Gjenbruker innhold som allerede er analysert",
  cockpit_report_progress_collecting: "Samler e-poster, chatter og oppgaver fra prosjektene dine",
  cockpit_report_progress_priorities: "Setter sammen prioriteringer, frister og beslutninger",
  cockpit_report_progress_queued: "Forbereder rapporten",
  cockpit_report_creating_title: "Dagsrapporten din blir forberedt",
  cockpit_report_progress_count_one: "1 element analysert",
  cockpit_report_progress_count_many: "{{count}} elementer analysert",
  cockpit_report_progress_hint: "Dette tar vanligvis ett til to minutter – du kan fortsette å bruke cockpit i mellomtiden.",
  cockpit_report_time_hint: "Dagsrapporten opprettes hver dag kl. {{hour}}:00 for de fem mest aktive prosjektene.",
  room_overview_priorities_title: "Gjeldende status og prioriteringer",
  room_overview_as_of: "Per {{time}}",
  cockpit_report_delete: "Slett dagsrapport",
  email_tag_daily_briefing: "Dagsrapport",
  cockpit_report_unread: "Ny",
  cockpit_report_clear_project: "Vis alle prosjekter",
  cockpit_filter_project: "Prosjekt",
  cockpit_filter_all_projects: "Alle prosjekter",
  cockpit_report_recreate: "Opprett dagsrapport på nytt",
  cockpit_report_hide_previous: "Skjul tidligere dagsrapporter",
  cockpit_report_show_previous: "Vis tidligere dagsrapporter",
  cockpit_report_room_empty: "Ingen dagsrapport for dette prosjektet ennå",
  cockpit_report_empty: "Ingen dagsrapport ennå",
  cockpit_report_room_empty_hint: "Opprett en dagsrapport bare for dette prosjektet.",
  cockpit_report_needs_mailbox: "Koble til en e-postkonto slik at Kjuup kan lage en dagsrapport med automatiske oppgaver.",
  cockpit_report_create: "Opprett dagsrapport",
  cockpit_email_connect: "Koble til e-post",
  cockpit_email_none_title: "Ingen e-postkonto tilkoblet ennå",
  cockpit_email_none_reports: "Koble til postkassen din slik at Kjuup kan knytte innkommende e-poster til prosjektene dine og lage dagsrapporter med oppgaver.",
  cockpit_email_none_client: "Koble til Gmail, Outlook eller IMAP for å lese, knytte og besvare e-poster direkte i Kjuup.io.",
  cockpit_email_reports_title: "Gjeldende e-postklient",
  cockpit_email_reports_text: "Ingen innboks i Kjuup.io · {{rooms}} prosjekter med dagsrapport kl. {{hour}}:00 · innkommende e-poster knyttes til prosjektene dine.",
  cockpit_email_reports_rooms: "Administrer prosjekter",
  cockpit_email_settings: "E-postinnstillinger",
  cockpit_email_error_title: "Kontroller tilkoblingen",
  cockpit_email_client_title: "Innboks tilkoblet",
  cockpit_email_accounts_n: "{{n}} konto tilkoblet",
  cockpit_email_last_sync: "siste synkronisering {{when}}",
  cockpit_email_report_at: "Dagsrapport kl. {{hour}}:00",
  cockpit_email_open_inbox: "Åpne innboksen",
  cockpit_email_eyebrow: "Kjuup-e-post",
  cockpit_email_accounts_label: "Tilkoblede e-postadresser",
  email_folder_sent: "Sendte elementer",
  email_no_subject: "(Ingen emne)",
  cockpit_email_detail_loading: "Laster e-post …",
  cockpit_email_detail_failed: "E-posten kunne ikke lastes.",
  cockpit_email_detail_empty: "Denne e-posten har ingen tekst.",
  cockpit_personal_settings: "Personlige innstillinger",
  cockpit_companies: "Firmaer",
  cockpit_title: "Cockpit",
  cockpit_back: "Tilbake til oversikten",
  cockpit_day_overview: "Dagen din i korte trekk",
  email_saved_to_project: "E-post lagret i prosjektet",
  email_classify_need_project: "Skriv inn et prosjektnavn",
  cockpit_email_deleted: "E-post slettet",
  cockpit_email_sent_empty: "Ingen sendte e-poster ennå.",
  cockpit_email_incoming_empty: "Ingen innkommende e-poster ennå.",
  cockpit_email_incoming_title: "E-poster",
  cockpit_email_incoming_sub: "Knytt innkommende og sendte e-poster til prosjektene dine. Du kan justere tilknytningen her.",
  cockpit_email_incoming_unassigned_n: "{{n}} ikke knyttet",
  cockpit_email_folder_inbox: "Innboks",
  cockpit_email_folder_sent: "Sendt",
  cockpit_email_open: "Åpne e-post",
  cockpit_email_incoming_suggested: "Forslag: {{room}}",
  cockpit_email_incoming_apply: "Bruk",
  cockpit_email_incoming_adjust: "Juster tilknytning",
  cockpit_email_incoming_saving: "Lagrer …",
  cockpit_email_incoming_unassigned: "Ikke knyttet",
  cockpit_email_incoming_show_less: "Vis færre",
  cockpit_email_incoming_show_all: "Vis alle {{n}}",
  cockpit_io_settings: "Kjuup.io-innstillinger",
  cockpit_io_settings_sub: "Abonnement og plasser, tildeling av ansatte, fakturering og fakturaer.",
  products_coming_soon: "Kommer snart",
  cockpit_upsell_io_title: "Kontoret ditt som tenker med",
  cockpit_upsell_io_text: "Koble e-postkontoene dine til Kjuup. E-poster, vedlegg og meldinger lagres automatisk i riktig prosjekt og kan eventuelt lagres på din egen server. Hver dag får du en oppsummering av alle prosjekter med hovedpunktene fra alt innhold, og oppgavene dine synkroniseres med kalenderen eller to do-appen din.",
  cockpit_upsell_io_soon_title: "Kan ikke bestilles ennå",
  cockpit_upsell_io_soon_text: "Kjuup.io lanseres snart. Be om informasjon nå – vi gir deg beskjed så snart du kan bestille Kjuup.io.",
  cockpit_upsell_io_planned_price: "Planlagt pris",
  cockpit_upsell_io_cta_request: "Be om informasjon",
  kjuup_plus_abo_per_year: "/ år",
  kjuup_plus_abo_per_month: "/ måned",
  kjuup_plus_abo_status_active: "Aktiv",
  kjuup_plus_abo_status_requested: "Oppsigelse forespurt",
  kjuup_plus_abo_status_past_due: "Betaling forfalt",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Abonnement",
  kjuup_plus_abo_title: "Kjuup+-pakke",
  kjuup_plus_abo_seats_free_one: "1 plass igjen",
  kjuup_plus_abo_billing: "Fakturering",
  kjuup_plus_abo_yearly: "Årlig",
  kjuup_plus_abo_monthly: "Månedlig",
  kjuup_plus_abo_amount: "Beløp",
  kjuup_plus_abo_ends: "Utløper",
  kjuup_plus_abo_renews: "Neste fornyelse",
  kjuup_plus_abo_next_invoice: "Neste faktura",
  kjuup_plus_abo_intro: "Introduksjonspris",
  kjuup_plus_abo_pending_tier: "Fra neste fornyelse",
  kjuup_plus_abo_manual: "Kjuup+ er aktivt for firmaet ditt i henhold til en individuell avtale.",
  kjuup_plus_abo_invoices: "Fakturaer",
  kjuup_plus_abo_invoice_paid: "Betalt",
  kjuup_plus_abo_invoice_view: "Vis",
  kjuup_plus_abo_invoices_less: "Vis færre",
  kjuup_plus_abo_member_hint: "Fakturering og oppsigelse administreres av firmaets administratorer.",
  kjuup_plus_abo_withdraw: "Trekk tilbake forespørsel",
  kjuup_plus_abo_cancel_note: "Årsak (valgfritt)",
  kjuup_plus_abo_cancel_send: "Be om oppsigelse",
  kjuup_plus_abo_cancel: "Si opp abonnementet",
  cockpit_upsell_plus_f1: "Administrer alle ansattes kommunikasjonsaktivitet",
  cockpit_upsell_plus_f2: "Informer bestemte brukergrupper i firmaet",
  cockpit_upsell_plus_f3: "Lagre interne gruppechatter",
  cockpit_upsell_plus_when_yearly: "ved årlig betaling",
  cockpit_upsell_plus_size_small: "1–50 ansatte",
  cockpit_upsell_plus_size_large: "51–200 ansatte",
  cockpit_upsell_plus_title: "Kjuup+ for firmaer",
  cockpit_upsell_plus_text: "Administrer ansatte, skrivetillatelser og firmakommunikasjon på ett sted. Interne kanaler forblir hos teamet ditt, eksterne kanaler kobler deg til prosjektpartnere, og du kan nå bestemte grupper direkte. I tillegg til Kjuup+ kan du bestille Kjuup.io-tilgang for ansattgrupper. Kjuup+ og Kjuup.io kan kombineres.",
  cockpit_upsell_plus_size: "Firmastørrelse",
  cockpit_upsell_plus_billing: "Fakturering",
  cockpit_upsell_plus_per_company: "/ firma · måned ekskl. mva.",
  cockpit_upsell_plus_onboarding: "Kostnader for onboarding/innføring avhenger av firmastørrelsen",
  cockpit_upsell_plus_larger: "Priser for større firmaer på forespørsel",
  cockpit_upsell_plus_cta: "Uforpliktende forespørsel",
  cockpit_kpi_deadlines_tasks: "Frister og oppgaver",
  cockpit_kpi_appointments: "Avtaler",
  cockpit_room_admin: "Prosjekt- og chatadministrasjon",
  cockpit_room_admin_sub: "Alle firmaets prosjekter med medlemmer, medier og chatter.",
  pro_todo_not_found: "Denne oppgaven er ikke lenger tilgjengelig.",
  cockpit_chip_overdue: "Forfalt",
  cockpit_chip_today: "I dag",
  cockpit_calendar_week: "Uke {{week}}",
  cockpit_prev_week: "Forrige uke",
  cockpit_next_week: "Neste uke",
  cockpit_chip_requested: "Forespurt",
  cockpit_todo_due: "Frist {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "fra {{name}}",
  cockpit_todo_since: "siden {{when}}",
  cockpit_todo_no_date: "Ingen dato",
  cockpit_todo_mark_done: "Merk som fullført",
  cockpit_my_tasks_title: "Mine oppgaver",
  cockpit_today_tasks_group: "Dagens oppgaver",
  cockpit_assign_none: "Ingen tildelt",
  no_project_found: "Fant ikke noe prosjekt",
  cockpit_row_more_actions: "Flere handlinger",
  needs_date: "Tildel dato",
  cockpit_assign_proposal: "{{name}} gjenkjent – tildele?",
  cockpit_assign_proposal_confirm: "Tildel",
  cockpit_assign_proposal_dismiss: "Ignorer",
  cockpit_priority_date: "Dato",
  todo_calendar_add: "Legg til i kalenderen",
  todo_calendar_remove: "Fjern fra kalenderen",
  cockpit_todo_change_project: "Bytt prosjekt",
  cockpit_todo_set_date: "Angi dato",
  pro_todo_done_confirm: "Vil du virkelig merke denne oppgaven som fullført?",
  cockpit_task_delete_failed: "Oppgaven kunne ikke slettes.",
  cockpit_setup_title: "Fullfør oppsettet",
  cockpit_setup_text: "Bestem om du vil bruke chatter, og om Kjuup.io skal fungere som e-postklient eller bare med prosjekter og dagsrapporter.",
  cockpit_setup_cta: "Sett opp nå",
  cockpit_group_tasks: "Frister og oppgaver",
  cockpit_group_appointments: "Avtaler",
  cockpit_report_no_activity: "Dette prosjektet hadde ingen nye meldinger eller e-poster de siste 24 timene.",
  cockpit_report_room_unavailable: "Dette prosjektet er ikke tilgjengelig.",
  cockpit_report_create_failed: "Dagsrapporten kunne ikke opprettes.",
  cockpit_report_created: "Dagsrapport opprettet",
  addon_enable_confirm: "Aktivere tillegget?",
  addon_enable: "Aktiver",
  addon_enabled: "Tillegg aktivert",
  nav_email: "E-post",
  nav_my_cockpit: "Min cockpit",
  nav_news: "Nyheter",
  nav_recommend: "Anbefal",
  pro_todo_status_done: "Fullført",
  pro_todo_status_open: "Åpen",
  v2_todo_remove: "Fjern",
  pro_todo_search_people: "Søk etter personer",
  pro_todo_clear: "Tøm",
  pro_todo_assigned: "(tildelt)",
  pro_todo_no_people: "Fant ingen personer",
  pro_todo_search_rooms: "Søk etter prosjekter",
  pro_todo_no_rooms_match: "Ingen prosjekter samsvarer med «{{q}}»",
  pro_todo_no_rooms: "Fant ingen prosjekter",
  pro_todo_activity: "Aktivitet",
  pro_todo_show_less: "Vis færre",
  pro_todo_show_all: "Vis alle ({{n}})",
  pro_todo_due: "Frist",
  pro_todo_room: "Prosjekt",
  pro_todo_select_room: "Velg prosjekt",
  pro_todo_status: "Status",
  pro_todo_more: "Mer",
  pro_todo_edit_title: "Rediger oppgave",
  pro_todo_description: "Beskrivelse",
  pro_todo_created_by: "Opprettet av",
  pro_todo_chat: "Chat",
  navigate_to_source: "Gå til kilden",
  todo_calendar_connect_title: "Ingen kalender tilkoblet",
  todo_calendar_connect_body_web: "Koble til en kalender i innstillingene for kalendersynkronisering for å legge oppgaver til i den.",
  todo_calendar_connect: "Koble til",
  todo_calendar_removed: "Fjernet fra kalenderen din",
  todo_calendar_added_later: "Lagt til. Kalenderen din kunne ikke nås; Kjuup prøver igjen senere.",
  todo_calendar_added: "Lagt til i kalenderen din",
  todo_calendar_no_date: "Bare en oppgave med dato kan legges til i en kalender.",
  todo_calendar_failed: "Kalenderen din kunne ikke oppdateres. Prøv igjen.",
  todo_calendar_date_title: "Ingen dato ennå",
  todo_calendar_date_save: "Angi dato og legg til",
  todo_calendar_date_body_web: "Denne merkede oppgaven har ingen dato ennå. Angi en for å legge den til i kalenderen din.",
  kjuup_io_setup_saved: "Oppsett lagret",
  kjuup_io_setup_step: "Trinn",
  kjuup_io_setup_chats_title: "Vil du bruke chatter?",
  kjuup_io_setup_email_title: "Hvor vil du lese e-postene dine?",
  kjuup_io_setup_chats_sub: "Chatter med kolleger og prosjektpartnere er valgfrie. Du kan vise eller skjule dem i cockpit når som helst.",
  kjuup_io_setup_email_sub: "Dette avgjør bare om du bruker en e-postklient i Kjuup eller fortsetter med e-postprogrammet du bruker nå, for eksempel Outlook eller et annet. Du kan bytte senere.",
  kjuup_io_setup_chats_yes: "Ja, vis chatter",
  kjuup_io_setup_chats_yes_text: "Meldinger inneholder chatter og e-poster. Prosjekter har gruppechatter for alle involverte.",
  kjuup_io_setup_chats_no: "Nei, jobb uten chatter",
  kjuup_io_setup_chats_no_text: "Chatter er skjult. «Meldinger» blir til «E-post»; prosjekter, oppgaver og dagsrapporter forblir.",
  kjuup_io_setup_email_client: "E-postklient i Kjuup",
  kjuup_io_setup_email_client_text: "Les og svar på e-poster direkte i Kjuup.",
  kjuup_io_setup_email_reports: "Gjeldende e-postklient",
  kjuup_io_setup_email_reports_text: "Fortsett å lese og svare i programmet du bruker nå, for eksempel Outlook eller et annet.",
  kjuup_io_setup_skip: "Senere",
  next: "Neste",
  kjuup_io_setup_finish: "Fullfør oppsettet",
  today_label: "i dag",
  tomorrow_label: "i morgen",
  cockpit_todo_overdue: "forfalt",
  cockpit_report_management_fazit: "Sammendrag for ledelsen",
  cockpit_todo_appointment: "Avtale",
  cockpit_todo_deadline: "Frist",
  cockpit_todo_deadline_define: "Angi frist",
  pro_todo_status_acknowledged: "Bekreftet",
  pro_todo_responsible: "Ansvarlig",
  pro_todo_notice_confirmed: "Bekreftet i chatten",
  pro_todo_notice_sent_at: "Melding sendt",
  pro_todo_notice_again: "Send meldingen på nytt",
  pro_todo_notice_send: "Informer via Kjuup-melding",
  pro_todo_add_assignee: "Legg til",
  pro_todo_edit: "Rediger",
  pro_todo_change_room: "Bytt prosjekt",
  pro_todo_due_on: "Frist den",
  pro_todo_edit_due: "Rediger frist",
  pro_todo_no_date: "Ingen dato",
  pro_todo_edit_description: "Rediger beskrivelse",
  pro_todo_no_description: "Ingen beskrivelse ennå",
  pro_todo_title_label: "Tittel",
  pro_todo_title_placeholder: "Skriv inn tittel...",
  pro_todo_task: "Oppgave",
  pro_todo_what: "Hva må gjøres?",
  pro_todo_source_email: "E-post",
  pro_todo_sources: "Kilder",
  previous: "Forrige",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (opptil {max} ansatte)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (opptil {max} ansatte)",
  kjuup_plus_abo_status_ends: "Avsluttes {date}",
  kjuup_plus_abo_seats_over: "Flere enn {max} ansatte – Kjuup kontakter deg med et tilpasset tilbud.",
  kjuup_plus_abo_seats_next: "Kommer det til flere ansatte, bytter pakken automatisk til {next} (forholdsmessig beregnet).",
  kjuup_plus_abo_seats_used: "{used} av {total} plasser brukt",
  kjuup_plus_abo_seats_free: "{count} plasser igjen",
  kjuup_plus_abo_intro_until: "til {date}",
  kjuup_plus_abo_invoice_open: "Åpen · forfaller {date}",
  kjuup_plus_abo_invoices_all: "Vis alle {count}",
  kjuup_plus_abo_requested_hint: "Oppsigelse forespurt {date}. Kjuup bekrefter den ved slutten av perioden ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup vurderer forespørselen din og bekrefter oppsigelsen ved slutten av perioden ({end}). Kjuup+ er aktiv frem til da.",
  kjuup_plus_abo_withdrawn: "Oppsigelsesforespørsel trukket tilbake",
  kjuup_plus_abo_requested: "Oppsigelse forespurt",
  cockpit_upsell_plus_intro_hint: "første {months} måneder, deretter {price}",
  cockpit_upsell_plus_badge: "INTROPRIS I {months} MÅNEDER",
  calendar_syncing: "Oppdaterer fra kalenderen…",
  calendar_sync_up_to_date: "Kalenderen er à jour",
  calendar_sync_failed: "Synkronisering mislyktes",
  delete_multiple_tasks_confirm: "Er du sikker på at du vil slette {count} ToDo-er?",
  todos_deleted_count: "{count} ToDo-er slettet",
  todos_deleted_partial: "{ok} ToDo-er slettet, {fail} feilet",
  todo_unknown: "Ukjent",
  todo_created_from_message: "Oppgave opprettet fra denne meldingen",
  kjuup_io_todo_calendar_trial_ended_note: "Kalendersynkronisering · Abonner",
  kjuup_io_todo_calendar_nudge: "Synkronisere denne ToDo-en til kalenderen din?",
  kjuup_io_todo_calendar_nudge_cta: "Aktiver Kjuup.io",
  todo_confirmed: "ToDo bekreftet",
  pro_todo_bulk_delete_title: "Slette {{n}} oppgaver?",
  pro_todo_previous_none_own: "De forfalte oppgavene er tildelt deg av andre og kan bare slettes av dem.",
  pro_todo_previous_none: "Ingen forfalte oppgaver",
  pro_todo_previous_title: "Slette {{n}} forfalte oppgaver?",
  pro_todo_previous_text: "Alle de åpne oppgavene dine fra tidligere dager blir slettet.",
  pro_todo_previous_skipped: "{{n}} tildelt av andre blir værende.",
  unassign_task_confirm: "Vil du avbryte tildelingen din for denne oppgaven?",
  unassign_label: "Avbryt",
  pro_todo_delete_title: "Slett oppgave",
  pro_todo_today: "I dag",
  pro_todo_yesterday: "I går",
  pro_todo_since_yesterday: "Siden i går",
  pro_todo_mark_open: "Merk som åpen",
  verify_completion: "Bekreft",
  new_label: "Ny",
  bookmarked_no_mylist: "Bokmerkede oppgaver kan ikke legges til i Min liste",
  delete_only_own: "Du kan bare slette oppgaver du selv har opprettet",
  todo_clear_all: "Tøm alle",
  pro_todo_of_completed: "{{done}} av {{total}} fullført",
  pro_todo_pick_date: "Velg en dato",
  pro_todo_show_day: "Vis dag",
  todo_adjust_list: "Juster listen",
  pro_todo_section_upcoming: "Kommende",
  pro_todo_section_done: "Fullført",
  pro_todo_room_empty_today: "Ingen oppgaver i dag i dette prosjektet",
  pro_todo_room_empty_day: "Ingen oppgaver denne dagen i dette prosjektet",
  pro_todo_delete_previous: "Slett alle",
  todo_my_list_empty: "Dagen din er tom",
  todo_my_list_empty_hint: "Klikk på «Tilpass liste» for å legge til oppgaver",
  pro_todo_empty_title: "Ingenting her",
  pro_todo_empty_hint: "Ingen oppgaver samsvarer med denne visningen.",
  pro_todo_selected: "{{n}} valgt",
  delete_selected_count: "Slett ({count})",
  pro_todo_adjust_done: "Ferdig",
  pro_todo_deleting: "Sletter...",
  pro_todo_reopen: "Gjenåpne oppgave",
  pro_todo_step_done: "Fullført",
  move_back_in_progress: "Tilbake til pågående",
  pro_todo_mark_not_started: "Merk som ikke startet",
  back_into_in_progress: "Tilbake til pågående",
  pro_todo_mark_in_progress: "Merk som pågående",
  unassign_todo: "Avbryt tildeling av ToDo",
  pro_todo_open_room: "Åpne prosjekt",
  pro_todo_new_task: "Ny oppgave",
  select_user_back_to_in_progress: "Velg brukeren som skal flyttes tilbake til Pågår",
  cockpit_email_accounts_n_many: "{{n}} kontoer tilkoblet",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Kjuup-kontakter",
  combined_tab_teams: "Teams-kontakter",
  combined_bridge_failed: "Teams-kopien kunne ikke opprettes.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Kjuup- og Teams-kontakter: en ny gruppe opprettes som også vises i Microsoft Teams.",
  teams_new_chat_title: "Ny Teams-chat",
  teams_new_chat_topic: "Gruppenavn (valgfritt)",
  teams_new_chat_start: "Start chat",
  teams_new_chat_creating: "Oppretter chat…",
  teams_new_chat_forbidden: "Microsoft Teams tillater ikke denne chatten (f.eks. en person utenfor organisasjonen din eller en policy fra IT-avdelingen).",
  teams_new_chat_too_many: "For mange personer for én chat.",
  teams_new_chat_type_hint: "Skriv et navn for å søke i organisasjonen din.",
  teams_new_chat_directory_forbidden: "Organisasjonen din tillater ikke søk i katalogen. Bare personer fra Teams-chattene dine vises.",
  teams_new_chat_account: "Konto",
};
